export const ACCESS_TOKEN = 'Access-Token'
export const APP_LANGUAGE = 'App-Language'
export const CURRENT_CHILD = 'Current-Child'
export const CURRENT_CAMPUS = 'Current-Campus'
export const CURRENT_CONTACT = 'Current-Contact'
export const NOTICE_HISTORY = 'Notice-History'
export const UNIFORM_SHOPPING = 'Uniform-Shopping'
export const CURRENT_SCHOOLTEAMS = 'Current-SchoolTeams'

